
import { padStart } from 'lodash'
import { ref } from 'vue'
import { useIntersectionObserver } from '@vueuse/core'
/**
 * 生成随机码
 * @param len 随机码长度
 */
export const createRandomCode = (len = 6) => {
  const charset = `_0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz`
  const maxLen = charset.length
  let ret = ''
  for (let i = 0; i < len; i++) {
    const randomIndex = Math.floor(Math.random() * maxLen)
    ret += charset[randomIndex]
  }
  return ret
}

/**
 * 补足数字位数
 * @param digit 数字
 * @param len 位数
 */
export const fillDigit = (digit: number, len: number) => {
  return padStart('' + digit, len, '0')
}


export const getCookie = (cname:string) => {
  const name = cname + "="
  const ca = document.cookie.split(';')
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i]
    while (c.charAt(0) === ' ') c = c.substring(1)
    if (c.indexOf(name) !== -1) {
      return c.substring(name.length, c.length)
    }
  }
  return ""
}

export const setCookie = (c_name: string, value: string, exdays:number) => {
  const exdate = new Date()
  exdate.setTime(exdate.getTime() + (exdays * 24 * 60 * 60 * 1000))
  const expires = "expires=" + exdate.toUTCString()
  document.cookie = c_name + "=" + value + "; " + expires
}
export const dataToFile = (params: { type: string; fileName: string; data: any }) => {
  const type = params.type
  const fileName = params.fileName
  const data = params.data
  // 非IE 浏览器
  const url = window.URL.createObjectURL(new Blob([data], { type }))
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', `${fileName}`)
  document.body.appendChild(link)
  link.click()
  window.URL.revokeObjectURL(url)
}


export const useLazyData = (fn: () => void) => {
  const target = ref(null)
  const { stop } = useIntersectionObserver(target, ([{ isIntersecting }]) => { 
    if (isIntersecting) {
      fn()
      stop()
    }
  })
  return target
}

// 处理时间
export const formatDate = (date:any, fmt:any) => {
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  const o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  }
  for (const k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      const str = o[k] + ''
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str))
    }
  }
  return fmt
}

function padLeftZero(str: string | any[]) {
  return ('00' + str).substr(str.length)
}

/**
 * 判断设备
 */
export const isPC = () => {
  return !navigator.userAgent.match(/(iPhone|iPod|iPad|Android|Mobile|BlackBerry|Symbian|Windows Phone)/i)
}

// 数组里的对象根据某个字段排序
export const sortByKey = (array:any,key:any) => {
  return array.sort(function(a:any,b:any) {
    const x = a[key];
    const y = b[key];
    return ((x > y) ? - 1 : (( x < y ) ? 1 : 0));
  })
}